module.exports = __webpack_public_path__ + "img/play8.680058c8.png";